import PropTypes from 'prop-types';

const AnalysisBox = ({ children }) => (
  <div className="p-6 bg-white rounded-lg flex-1 flex flex-col gap-4 min-h-0 border border-gray-200">{children}</div>
);

AnalysisBox.propTypes = {
  children: PropTypes.node,
};

export default AnalysisBox;
